// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__es38b","card":"FAQ_card__rTAjf","container":"FAQ_container__s8q0j"};